import { Box, Button } from "@mui/material";
import styled from "styled-components";
import { BaseFormStyled } from "../../../../components/base-form/base-form.styles";

export const InitialDetailsStyled = styled(Box)``;

export const BaseForm = styled(BaseFormStyled)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  @media (min-width: 576px) {
    flex-direction: row;
  }
  > * {
    flex: 1;
    min-width: 0;
  }
  .MuiInputBase-root {
    background: var(--pure-white-color);
  }
  .autocomeplete-input {
    display: flex;
    flex-direction: column;
    position: relative;
 
    .loader {
      position: absolute;
      right: 10px;
      top: 50%;
    }
  }
  > * {
    flex-grow: 1;
  }
  .field-wrapper {
    .MuiTypography-root {
      font-weight: 500;
      font-size: 12px;
      color: var(--medium-gray-color);
    }
    .MuiFormControl-root {
      .MuiInputBase-root {
        .MuiInputBase-input {
          height: 40px;
          z-index: 1;
          padding: 8px 14px;
          font-size: 14px;
          font-weight: 400;
          &::placeholder {
            color: #606060;
          }
        }
        .MuiOutlinedInput-notchedOutline {
          border-color: #c3ccd7;
          box-shadow: 0px 1px 2px 0px #1018280d;
          background: var(--pure-white-color);
        }
      }
    }
  }
`;

export const AddClientButtonContainer = styled(Box)`
  padding: 16px 0 13px 0;
`;

export const AddClientButton = styled(Button)`
  text-transform: none !important;
  height: 36px;
  background: var(--pure-white-color) !important;
  border-radius: 16px !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: var(--royal-blue-color) !important;
  padding: 7.5px 10px !important;
`;
